/**
 * @author PoornaChandu
 * @description This Component is mainly for Creating Jobplans and Task
 * @View Table with crud operations of Jobplanes
 */
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import { Form, message, Col, Select, Tabs, Input, Modal, Button } from 'antd';
import { SearchOutlined, DownOutlined } from '@ant-design/icons';
import { decode as base64_decode } from 'base-64';

import TableSelect from '../../../Widgets/TableSelect';
import localStorage from '../../../../../utils/localStorage';
import {
  getSitesList,
  submitTask,
  getStatusListTask,
  getTaskById,
  getSkillTypeList
} from '../../../Utils/FormCalls';
import Highlighter from 'react-highlight-words';
import {
  StyledBox,
  StyledBoxHeader
} from '../../../CSS/style';
import { constant } from '../../../Utils/constants';
import FileBase64 from '../../../Utils/FileUpload';
import translation from '../../../../../commons/translation';
import {
  ItemForm,
  ToolsForm,
  LaborForm,
  MaterialForm,
  FieldDataType,
  ObservationType
} from './TaskRequirements';
import InputComponent from '../../../Widgets/InputComponent';
import {
  API_DEVICE
} from '../../../../../commons/api';
import { useNavigate } from 'react-router-dom';
import { StyledHomepageSides, StyledTabs } from '../../../../../commons/styles/layout';

const { Option } = Select;
const { TabPane } = Tabs;
const fileData = new FormData();

const TaskForm = (props) => {
  // const [deviceList, setDeviceList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [sitesList, setSitesList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  // const [dropdownSelection, setDropdownSelection] = useState({ deviceId: '' });
  const [SkillTypeList, setSkillTypeList] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [formObject, setFormObject] = useState({});
  // const [hierarchyList, setHierarchyList] = useState([]);
  const formHeader = useRef(null);
  const searchInput = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    await _getDataById();
    // try {
    //   const hierarchyList = await getHierarchyList();
    //   setHierarchyList(hierarchyList);
    // } catch (error) {
    //   message.warn(`${error.message}`);
    // }
    try {
      const sitesList = await getSitesList();
      let formObject = formHeader.current ? formHeader.current.getFieldsValue() : {};
      formObject = {
        ...formObject,
        SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
      };
      if (formHeader.current) formHeader.current.setFieldsValue(formObject);
      setSitesList(sitesList);
      // setFormObject(formObject);
    } catch (error) {
      message.warn(`${error.message}`);
    }
    const SkillTypeList = await getSkillTypeList();
    setSkillTypeList(SkillTypeList);
    try {
      const statusList = await getStatusListTask();
      setStatusList(statusList);
    } catch (error) {
      message.warn(`${error.message}`);
    }
    // try {
    //   const usersList = await getUsersList();
    //   setUsersList(usersList);
    // } catch (error) {
    //   message.warn(`${error.message}`);
    // }
    // try {
    //   const uomList = await _getUOMList();
    //   setUomList(uomList);
    // } catch (error) {
    //   message.warn(`${error.message}`);
    // }
  };
  // useEffect(() => {
  //   if (props.history.location) {
  //     // onReset();
  //     // _getDataById();
  //   }
  // });
  useEffect(() => {
    setTranslationCache(props.translationCache);
  }, [props.translationCache]);

  const _getDataById = async (TaskId) => {
    let path = props.location.pathname.split('/rubus/AMM/TasksDetails/');
    let formId = TaskId ? TaskId : base64_decode(path[1]);
    if (formId !== 'new') {
      let formObject = await getTaskById(formId, 'withId');
      if (formObject && Array.isArray(formObject.ObservationType)) {
        formObject.ObservationType = formObject.ObservationType.map(item => ({
          ...item,
          EstimatedDuration: item.EstimatedDuration ? dayjs(item.EstimatedDuration) : undefined
        }));
      }
      setFormObject(formObject);
      if (formObject) {
        formHeader.current.setFieldsValue(formObject);
      }
    }
  };

  const handleSelect = (value, subindex, keyName, selectedObject) => {
    let data = formHeader.current.getFieldValue();
    if (keyName === 'Labor') {
      let skill = SkillTypeList.filter((item) => item.Id === selectedObject[0]['SkillTypeId']);
      if (data && data[keyName] && data[keyName][subindex]) {
        data[keyName][subindex]['SkillTypeName'] =
          skill && skill[0] && Array.isArray(skill) && skill[0].Type ? skill[0].Type : null;
        data[keyName][subindex]['Description'] = selectedObject[0]['Description'];
        data[keyName][subindex]['AvailableQuantity'] = selectedObject[0]['AvailableQuantity'];
      }
    } else {
      if (data && data[keyName] && data[keyName][subindex]) {
        data[keyName][subindex]['Description'] = selectedObject[0]['Description'];
        data[keyName][subindex]['AvailableQuantity'] = selectedObject[0]['AvailableQuantity'];
      }
    }
    formHeader.current.setFieldsValue(data);
    setFormObject(data);
  };
  const fileupload = async (values, key, fileDataObject) => {
    let file = fileDataObject;
    // let formObject = formHeader.current.getFieldsValue();
    if (formObject && formObject[key]) {
      formObject[key].push(...values);
    } else {
      formObject[key] = values;
    }
    // Removing duplicate file names
    formObject[key] = formObject[key].reduce((acc, current) => {
      const x = acc.find((item) => item.Name === current.Name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    let FormObject = {
      ...formObject,
      [key]: formObject[key]
    };
    fileData.append('files', file);
    formHeader.current.setFieldsValue(FormObject);
    setFormObject(FormObject);

  };

  const onFinish = async (values) => {
    // const hasFieldData = Array.isArray(values.FieldDataType) && values.FieldDataType.length > 0;
    // const hasObservation = Array.isArray(values.ObservationType) && values.ObservationType.length > 0;
    const hasFieldData = values?.FieldDataType?.length > 0 || formObject?.FieldDataType?.length > 0;
    const hasObservation = values?.ObservationType?.length > 0 || formObject?.ObservationType?.length > 0;
    if (!hasFieldData && !hasObservation) { return; }
    let payload = {
      ...formObject,
      ...values,
      TaskStatusId: values.TaskStatusId,
      ObservationType: Array.isArray(values.ObservationType)
        ? values.ObservationType.map(item => ({
          ...item,
          EstimatedDuration: item?.EstimatedDuration
            ? dayjs(item.EstimatedDuration).format('YYYY-MM-DD HH:mm:ss')
            : undefined
        }))
        : []
    };
    let statusResponse = await submitTask(payload, fileData);
    if (statusResponse && statusResponse.message) {
      message.success('Task submitted successfully').then(() => {
        navigate('/rubus/AMM/Tasks');
      });
      _getDataById(statusResponse.Id);
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    } else {
      // message.warning('Please Add Sub Task');
    }
  };

  const onDrawerCancel = () => {
    setVisible(false);
  };

  const getDeviceData = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        setTableData(data);
        setVisible(true);
        setFormObject(formHeader.current.getFieldsValue());
      })
      .catch(() => { });
  };
  const TableDropdownChange = (value) => {
    let formObject = formHeader.current.getFieldsValue();
    formObject = {
      ...formObject,
      Equipment: value.AliasCode,
      EquipmentDescription: value.Name,
      DeviceCode: value.DeviceCode,
      DisplayCode: value.DisplayCode
    };
    formHeader.current.setFieldsValue(formObject);
    setFormObject(formObject);
    setVisible(false);
  };
  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, `Search`)}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}
        >
          {translation(props.translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
  /* eslint-disable no-template-curly-in-string */
  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    }
  };
  return (
      <StyledHomepageSides>
        <Form
          name="TaskData"
          ref={formHeader}
          initialValues={formObject}
          onFinish={onFinish}
          layout="vertical"
          validateMessages={validateMessages}
        >

          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                {translation(translationCache, constant.submit)}
              </Button>
            </Form.Item>
          </div>
          <StyledBoxHeader>
            <StyledBox>
              <Form.Item
                label={translation(translationCache, constant.taskName)}
                name={'TaskName'}
                rules={[
                  { required: true }
                ]}
              >
                <InputComponent
                  placeholder={translation(translationCache, 'Enter Name')}
                  value={formObject && formObject.TaskName ? formObject.TaskName : ''}
                  style={{ width: '100%' }}
                  disabled={formObject && formObject.Id ? true : false}
                />
              </Form.Item>
              <Form.Item
                label={translation(translationCache, constant.taskDescription)}
                name={'TaskDescription'}
                rules={[{ required: true }]}
              >
                <InputComponent
                  placeholder={translation(translationCache, 'Enter Task Description')}
                  value={formObject && formObject.TaskDescription ? formObject.TaskDescription : ''}

                />
              </Form.Item>
              <Form.Item
                label={translation(translationCache, constant.equipment)}
                name="DisplayCode"
                rules={[{ required: true }]}
              >
                <Input
                  style={{ width: '100%' }}
                  // value={formObject.Location}
                  placeholder={translation(translationCache, 'Select Equipment')}
                  disabled={true}
                  suffix={
                    <DownOutlined
                      style={{
                        // color: '#1a3b5c',
                        color: formObject && formObject.Id ? null : '#1a3b5c',
                        cursor: formObject && formObject.Id ? 'not-allowed' : null,
                        opacity: formObject && formObject.Id ? '0.8' : null
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (formObject && !formObject.Id) {
                          getDeviceData('visible');
                        }
                      }}
                    />
                  }
                />
                {/* <Select
                  value={formObject.Equipment}
                  placeholder={translation(translationCache,"Select Equipment")}
                  disabled={true}
                  style={{ width: '100%' }}
                  suffixIcon={
                    <ApartmentOutlined
                      className="apartmentOutlined"
                      style={{
                        color: '#1a3b5c',
                        opacity: formObject && formObject.Id ? 0.5 : null
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        getHierarchyLevels(hierarchyList);
                      }}
                      // style={{ color: 'red !important' }}
                    />
                  }
                /> */}
              </Form.Item>
              <Form.Item
                label={translation(translationCache, constant.equipmentDescription)}
                name="EquipmentDescription"
                rules={[{ required: true }]}
              >
                <InputComponent
                  disabled={true}
                  style={{ width: '100%' }}
                  placeholder={translation(translationCache, 'Autopopulate Basis To The Equipment')}
                //maxLength={150}
                />
              </Form.Item>
              <Form.Item
                label={translation(translationCache, constant.site)}
                name="SiteId"
                rules={[{ required: true }]}
              >
                <Select
                  placeholder={translation(translationCache, 'Select Site')}
                  style={{ width: '100%' }}
                  disabled={formObject && formObject.Id ? true : false}
                >
                  {sitesList &&
                    Array.isArray(sitesList) &&
                    sitesList.map((site, index) => {
                      return (
                        <Option key={index} value={site.Id}>
                          {' '}
                          {site.Name}{' '}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
              <Form.Item
                label={translation(translationCache, constant.status)}
                name="TaskStatusId"
                rules={[{ required: true }]}
              >
                <Select
                  placeholder={translation(translationCache, 'Select Status')}
                  style={{ width: '100%' }}
                >
                  {statusList &&
                    Array.isArray(statusList) &&
                    statusList.map((status, index) => {
                      return (
                        <Option key={index} value={status.Value}>
                          {translation(translationCache, status.Key)}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
              <Form.Item
                label={translation(translationCache, constant.attachments)}
                name="Attachments"
              >
                <FileBase64
                  style={{ width: '100%' }}
                  downloadClassName={'formdownloadInput'}
                  Attachments={formObject && formObject.Attachments}
                  fileUpload={fileupload}
                ></FileBase64>
              </Form.Item>

            </StyledBox>
          </StyledBoxHeader>

          <StyledBoxHeader>
            <StyledTabs   type="card">
              <TabPane tab={translation(translationCache, 'Tools')} key="1">
                <Form.Item name="Tools">
                  <ToolsForm
                    quantity={'4'}
                    formObject={
                      formHeader && formHeader.current && formHeader.current !== null
                        ? formHeader.current.getFieldsValue()
                        : {}
                    }
                    onToolChange={handleSelect}
                    formHeader={formHeader}
                  />
                </Form.Item>
              </TabPane>
              <TabPane tab={translation(translationCache, 'ManPower')} key="2">
                <Col span={24}>
                  <Form.Item name="Labor">
                    <LaborForm
                      quantity={'4'}
                      formObject={
                        formHeader && formHeader.current !== null
                          ? formHeader.current.getFieldsValue()
                          : {}
                      }
                      onLaborChange={handleSelect}
                      formHeader={formHeader}
                    />
                  </Form.Item>
                </Col>
              </TabPane>
              <TabPane tab={translation(translationCache, 'Material')} key="3">
                <Col span={24}>
                  <Form.Item name="Materials">
                    <MaterialForm
                      quantity={'4'}
                      formObject={
                        formHeader && formHeader.current && formHeader.current !== null
                          ? formHeader.current.getFieldsValue()
                          : {}
                      }
                      onMaterialChange={handleSelect}
                      formHeader={formHeader}
                    />
                  </Form.Item>
                </Col>
              </TabPane>
              <TabPane tab={translation(translationCache, 'Items')} key="4">
                <Col span={24}>
                  <Form.Item name="Items">
                    <ItemForm
                      quantity={'4'}
                      formObject={
                        formHeader && formHeader.current !== null
                          ? formHeader.current.getFieldsValue()
                          : {}
                      }
                      onItemChange={handleSelect}
                      formHeader={formHeader}
                    />
                  </Form.Item>
                </Col>
              </TabPane>
              <TabPane tab={translation(translationCache, 'Field Data Type')} key="5">
                <Col span={24}>
                  <Form.Item name="FieldDataType">
                    <FieldDataType
                      quantity={'4'}
                      formObject={
                        formHeader && formHeader.current !== null
                          ? formHeader.current.getFieldsValue()
                          : {}
                      }
                      onFieldChange={handleSelect}
                      formHeader={formHeader}
                    />
                  </Form.Item>
                </Col>
              </TabPane>
              <TabPane tab={translation(translationCache, 'Observation Type')} key="6">
                <Col span={24}>
                  <Form.Item name="Observation">
                    <ObservationType
                      quantity={'4'}
                      formObject={
                        formHeader && formHeader.current !== null
                          ? formHeader.current.getFieldsValue()
                          : {}
                      }
                      onObservationChange={handleSelect}
                      formHeader={formHeader}
                    />
                  </Form.Item>
                </Col>
              </TabPane>
            </StyledTabs>
          </StyledBoxHeader>

              <Form.Item name="TaskName"></Form.Item>
              <Form.Item name="Equipment"></Form.Item>
              <Form.Item name="Id"></Form.Item>
              <Form.Item name="Labor"></Form.Item>
              <Form.Item name="Materials"></Form.Item>
              <Form.Item name="Items"></Form.Item>
        </Form>
        <Modal
          open={visible}
          width={1000}
          closable
          title={translation(translationCache, constant.selectEquipment)}
          onCancel={onDrawerCancel}
          onOk={onDrawerCancel}
        >
          <TableSelect
            data={tableData}
            translationCache={props.translationCache}
            key="Equipment"
            columns={[
              {
                title: translation(translationCache, 'Equipment'),
                dataIndex: 'DisplayCode',
                key: 'DisplayCode',
                ...getColumnSearchProps('DisplayCode')
              },
              {
                title: translation(translationCache, 'Equipment Description'),
                dataIndex: 'Name',
                key: 'Name',
                ...getColumnSearchProps('Name')
              }
            ]}
            handleDropdownChange={(e) => TableDropdownChange(e, 'visible')}
          />
          {/* <HierarchyModal
              value={deviceId}
              treeData={treeData}
              translationCache={props.translationCache}
              language={props.language}
              handleDropdownChange={hierarchyDropdownChange}
              deviceList={deviceList}
            /> */}
        </Modal>
      </StyledHomepageSides>
 
  );
};
const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache
  };
};
export default connect(mapStateToProps)(TaskForm);
